import {useEffect} from 'react';

export const useCloseOnEnterSpace = (onClose) => {
  useEffect(() => {
    if (!onClose) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
};
